import React from "react";
import {
  useCheckboxGroupItem,
  AriaCheckboxGroupItemProps,
  VisuallyHidden,
} from "react-aria";
import { GroupContext } from "./checkbox-group";
import { cx } from "../../utils/dom";
import { StyleProps } from "../../utils/types";

export interface CheckBoxItemProps
  extends AriaCheckboxGroupItemProps,
    StyleProps<"wrapper"> {
  className?: string;
}

export function CheckboxItem({
  className,
  classNames,
  styles,
  style,
  ...props
}: CheckBoxItemProps) {
  const ctx = React.useContext(GroupContext);
  if (!ctx) {
    throw new Error("CheckboxItem must be used within a CheckboxGroup");
  }

  const ref = React.useRef(null);
  const { inputProps } = useCheckboxGroupItem(props, ctx.state, ref);
  const isSelected = ctx.state.isSelected(props.value);
  const isDisabled = ctx.state.isDisabled || props.isDisabled;

  return (
    <label
      style={{ ...style, ...styles?.wrapper }}
      className={cx(className, "p-checkbox-item", classNames?.wrapper)}
      data-disabled={isDisabled}
      data-checked={isSelected}
    >
      <VisuallyHidden>
        {" "}
        <input type="checkbox" ref={ref} {...inputProps} />
      </VisuallyHidden>
      {props.children}
    </label>
  );
}
